import { userHasRole } from "../utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    return Boolean(user);
  },

  view: ({ user, claim }) => {
    // check if user kunde_id_ov matches claim kunde_id_ov
    if (userHasRole(user, ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"])) {
      return true;
    }

    if (
      claim &&
      user.kunde_id_ov &&
      claim.kunde_id_ov &&
      user.kunde_id_ov === claim.kunde_id_ov
    ) {
      return true;
    }

    return false;
  },

  update: ({ user, claim }) => {
    // check if user kunde_id_ov matches claim kunde_id_ov
    if (userHasRole(user, ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"])) {
      return true;
    }

    return false;
  },

  updateForm: ({ user, claim }) => {
    // check if user kunde_id_ov matches claim kunde_id_ov
    if (userHasRole(user, ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"])) {
      return true;
    }

    if (
      claim &&
      user.kunde_id_ov &&
      claim.kunde_id_ov &&
      user.kunde_id_ov === claim.kunde_id_ov
    ) {
      return true;
    }

    return false;
  },

  generatePdf: ({ user, claim }) => {
    // check if user kunde_id_ov matches claim kunde_id_ov
    if (userHasRole(user, ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"])) {
      return true;
    }

    return false;
  },

  exportZip: ({ user }) => {
    return userHasRole(user, ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"]);
  },
};
